import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "Client/";

const getClientById = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetClientById?id=' + id, constants.REQUIRE_INTERCEPTORS);

const getClients = async () => await axiosInstance.get(ENDPOINTORIGIN + 'GetClients', constants.REQUIRE_INTERCEPTORS);

const saveClient = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'SaveClient', model, { ...constants.REQUIRE_INTERCEPTORS, fileHandler: true });

const updateClient = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'UpdateClient', model, constants.REQUIRE_INTERCEPTORS);

const updateClientLogo = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'UpdateClientLogo', model, { ...constants.REQUIRE_INTERCEPTORS, fileHandler: true })

const getAllClientEmails = async (clientId) => await axiosInstance.get(ENDPOINTORIGIN + 'GetAllClientEmails?clientId=' + clientId, constants.REQUIRE_INTERCEPTORS);

export {
    getClientById,
    getClients,
    saveClient,
    updateClient,
    updateClientLogo,
    getAllClientEmails
}